import { ReactElement } from 'react';
import styled from 'styled-components';

interface TabPanelProps {
  label: string;
  children?: ReactElement;
}

/**
 * @deprecated Please use TabPanel in molecules/Tabs/Tabs.styles.ts
 */

export const HeaderTabPanel = (props: TabPanelProps) => {
  return <PanelContainer>{props.children}</PanelContainer>;
};

export const HeaderTabPanelType = (
  <HeaderTabPanel label="">
    <></>
  </HeaderTabPanel>
).type;

export const HeaderTabPanelContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
  width: 100%;
  height: 100%;
`;

export const HeaderTabContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 2;
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const HeaderTabContent = styled.div<{
  active: boolean;
}>`
  display: flex;
  overflow: hidden;
  width: ${(props) => (props.active ? '100%' : '0%')};
  transition: all ease-in-out 0.3s;
`;

const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  margin: 15px 32px 32px 32px;
`;
